var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContainerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5898",
    "data-name": "Path 5898",
    d: "M23.641,12.872A.36.36,0,0,0,24,12.513V10.359A.36.36,0,0,0,23.641,10H21.487a.36.36,0,0,0-.359.359v.718H12.872v-.718A.36.36,0,0,0,12.513,10H10.359a.36.36,0,0,0-.359.359v2.154a.36.36,0,0,0,.359.359h.718v8.256h-.718a.36.36,0,0,0-.359.359v2.154a.36.36,0,0,0,.359.359h2.154a.36.36,0,0,0,.359-.359v-.718h8.256v.718a.36.36,0,0,0,.359.359h2.154A.36.36,0,0,0,24,23.641V21.487a.36.36,0,0,0-.359-.359h-.718V12.872Zm-1.436,8.256h-.718a.36.36,0,0,0-.359.359v.718H12.872v-.718a.36.36,0,0,0-.359-.359h-.718V12.872h.718a.36.36,0,0,0,.359-.359v-.718h8.256v.718a.36.36,0,0,0,.359.359h.718Z",
    transform: "translate(-10 -10)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerIcon);
export default __webpack_public_path__ + "static/media/container_icon.2009c7d5caf8a9d57af679cf5d52b186.svg";
export { ForwardRef as ReactComponent };